import React, { useRef } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Navigation, Autoplay } from 'swiper/modules';

import "../assets/css/websites.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import CobbAndJones from "../assets/images/cob&jones.png";
import NorthShore from "../assets/images/northshore.png";
import NCF from "../assets/images/ncf.png";
import Ontrad from "../assets/images/ontrad.png";

export default function SwiperComponent() {

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <div className="websites">
            <div>
                <button ref={prevRef} className='prev'>
                    <IoIosArrowDropleftCircle />
                </button>
            </div>
            <Swiper
                onInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                }}
                style={{ marginBottom: "20px" }}
                slidesPerView={4}
                breakpoints={{
                    200: { slidesPerView: 1 },
                    650: { slidesPerView: 2 },
                    1025: { slidesPerView: 3 },
                    1658: { slidesPerView: 4 }
                }}
                spaceBetween={30}
                navigation={
                    {
                        nextEl: '.next',
                        prevEl: '.prev'
                    }}
                autoplay={{
                    delay: 5000, // Slide every 5 seconds
                    disableOnInteraction: false // Allow autoplay to continue after user interaction
                }}
                loop={true} // Enable infinite looping
                modules={[Navigation, Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <div className="website-component">
                        <img src={CobbAndJones} alt="Cobb And Jones" className="website-image" />
                        <h4 className="website-title">Cobb And Jones</h4>
                        <p className="website-description">
                            This website was created for Cobb And Jones. They area a group of well renowned lawyers in the Norfolk area.
                        </p>
                        <a href="https://northshoresoapworks.com/" target="_blank" rel="noreferrer" className="website-link">Visit <IoIosArrowRoundForward /></a>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="website-component">
                        <img src={NorthShore} alt="North Shore Soapworks" className="website-image" />
                        <h4 className="website-title">North Shore Soapworks</h4>
                        <p className="website-description">
                            This website is a beautifully designed online store for North Shore Soapworks array of soaps they sell.
                        </p>
                        <a href="https://northshoresoapworks.com/" target="_blank" rel="noreferrer" className="website-link">Visit <IoIosArrowRoundForward /></a>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="website-component">
                        <img src={NCF} alt="Norfolk Community Foundation" className="website-image" />
                        <h4 className="website-title">Norfolk Community Foundation</h4>
                        <p className="website-description">
                            This website was built for the community of Norfolk County. It is a place where you can donate to people in your community who need your help.
                        </p>
                        <a href="https://www.norfolkcommunityfoundation.com/" target="_blank" rel="noreferrer" className="website-link">Visit <IoIosArrowRoundForward /></a>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="website-component">
                        <img src={Ontrad} alt="Ontario Traditional Music" className="website-image" />
                        <h4 className="website-title">Ontario Traditional Music</h4>
                        <p className="website-description">
                            This website was built for traditional music lovers. It has hundreds of songs and videos for you to enjoy.
                        </p>
                        <a href="https://www.norfolkcommunityfoundation.com/" target="_blank" rel="noreferrer" className="website-link">Visit <IoIosArrowRoundForward /></a>
                    </div>
                </SwiperSlide>
            </Swiper>
            <div>
                <button ref={nextRef} className='next'>
                    <IoIosArrowDroprightCircle />
                </button>
            </div>
        </div>
    );
}
